import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Form } from 'react-bootstrap';

const CheckVideoType = () => {
	const navigate = useNavigate();
	const videoTypes = [
		{ id: '1', name: 'Classes', path: '/AdminDashboard/AddClassVideos' },
		{ id: '2', name: 'Library', path: '/AdminDashboard/AddVideos(vimeo)' }
	];

	const [videoType, setVideoType] = useState(''); // Default to empty string

	const handleSubmit = () => {
		const selectedType = videoTypes.find(type => type.id === videoType);
		if (selectedType) {
			navigate(selectedType.path);
		} else {
			alert('Please select a video type!');
		}
	};

	return (
		<div className="check_body">
			<Form>
				<Form.Group controlId="videoType">
					<Form.Label>Please select the type of video you want to add from the below options</Form.Label>
					<Form.Control as="select" value={videoType} onChange={e => setVideoType(e.target.value)}>
						<option value="">-- Select an option --</option>
						{videoTypes.map(type => (
							<option key={type.id} value={type.id}>
								{type.name}
							</option>
						))}
					</Form.Control>
				</Form.Group>
			</Form>
			<Button onClick={handleSubmit} disabled={!videoType}>
				Submit
			</Button>
		</div>
	);
};

export default CheckVideoType;
